import React, { useEffect, useState } from "react";
import { ReactComponent as Checked } from "../../assets/analyse/Checked.svg";
import { ReactComponent as Unchecked } from "../../assets/analyse/Unchecked.svg";
// import { columnsNames } from "../../css/columns";
import { useSelector, shallowEqual } from "react-redux";
import { accordionClasses } from "@mui/material";
import { calculImpactStepResult, calculImpactStepResultOpt, calculStepResultQuantity } from "../../utils/utils.js";

const StepResultRight = ({ result, columns, totalScore, step_index, is_reduce }) => {
  const analysis_data = useSelector((state) => state.analysis.analysis_data, shallowEqual); //? state.analysis.analysis_data : null)
  const optimization_data = useSelector((state) => state.optimization.optimization_data, shallowEqual);
  const impact_indicators = useSelector((state) => (state.analysis.impact_indicators ? state.analysis.impact_indicators : null));

  const handleOnChangeCheckedStepResult = () => {
    // check if all previous steps are checked
    let is_checked_step_result;
    if (is_reduce) {
      is_checked_step_result = false;
      if (Object.values(optimization_data.lca.lca_steps)[Math.abs(step_index - 6)].inputs) {
        is_checked_step_result = Object.values(Object.values(optimization_data.lca.lca_steps)[Math.abs(step_index - 6)].inputs).every((x) => {
          return x && x.checked;
        });
      } else if (Object.values(optimization_data.lca.lca_steps)[Math.abs(step_index - 6)].outputs) {
        is_checked_step_result = Object.values(Object.values(optimization_data.lca.lca_steps)[Math.abs(step_index - 6)].outputs)[0].checked;
      }
    } else {
      if (Object.values(analysis_data.lca.lca_steps)[Math.abs(step_index - 6)].inputs) {
        is_checked_step_result = Object.values(Object.values(analysis_data.lca.lca_steps)[Math.abs(step_index - 6)].inputs).every((x) => {
          return x.checked;
        });
      } else if (Object.values(analysis_data.lca.lca_steps)[Math.abs(step_index - 6)].outputs) {
        is_checked_step_result = Object.values(Object.values(analysis_data.lca.lca_steps)[Math.abs(step_index - 6)].outputs)[0].checked;
      }
    }

    return is_checked_step_result;
  };

  const [impactt, setImpactt] = useState(null);

  useEffect(() => {
    const calc_fn = async () => {
      setImpactt(
        ((is_reduce
          ? calculImpactStepResultOpt(optimization_data, "da32f256-618d-4bec-a8d9-205817788b26", step_index)
          : calculImpactStepResult(analysis_data, "da32f256-618d-4bec-a8d9-205817788b26", step_index)) /
          totalScore) *
          100
      );
    };
    calc_fn();
  });

  return (
    <div className={`h-[40px]  bg-blue-300/30 flex items-center w-max`}>
      <div className=" h-[40px] flex justify-start items-center">
        {/* QUANTITY */}
        <div key={"quantity"} className={`flex pl-[40px] justify-center items-center h-[40px] w-[140px] text-sm font-Poppins-Regular`}>
          <p>{is_reduce ? calculStepResultQuantity(optimization_data, step_index) : calculStepResultQuantity(analysis_data, step_index) + " kg"}</p>
        </div>

        {/* IMPACT PERCENT */}
        <div key={"impact_percent"} className={`flex justify-evenly items-center h-[40px] w-[140px] border-dotted border-[1px] text-sm font-Poppins-Regular`}>
          <div className="h-[40px] w-[54.5px] flex justify-end items-center">
            <p className="mr-[10px]">{impactt && impactt.toFixed(2)}</p>
          </div>
          <div className="w-[60px] h-[5px] bg-[#BEC4CA]/50 rounded-xl mr-[5px] flex justify-start"></div>
        </div>

        {columns.map((current, i) => {
          const indicator_impact = is_reduce
            ? parseFloat(calculImpactStepResultOpt(optimization_data, current, step_index)).toFixed(2)
            : parseFloat(calculImpactStepResult(analysis_data, current, step_index)).toFixed(2);
          const indicator_unit = impact_indicators.find((target) => target.id === current).ref_unit;
          return (
            <div key={`${i}`} className={`flex justify-center items-center h-[40px] w-[${impact_indicators.find((target) => target.id === current).width}px] text-sm font-Poppins-Regular`}>
              {indicator_impact} {indicator_unit}
            </div>
          );
        })}

        <div key={"validate"} className={`flex justify-center items-center h-[40px]  w-[100px] border-dotted border-[1px] text-sm font-Poppins-Regular`}>
          {handleOnChangeCheckedStepResult() ? <Checked height={30} /> : <Unchecked height={30} />}
        </div>
      </div>
    </div>
  );
};

export default StepResultRight;
